import { jsx as _jsx } from "react/jsx-runtime";
export function Heading({ level, children }) {
    if (level === 1) {
        return (_jsx("div", { className: "my-3 border-b border-zinc-950/10 py-2 dark:border-white/10 [&+ul]:-mt-3", children: _jsx("h1", { className: "text-sm font-medium leading-6 text-zinc-950 dark:text-white", children: children }) }));
    }
    if (level === 2) {
        return (_jsx("div", { className: "my-3 border-b border-zinc-950/10 dark:border-white/10", children: _jsx("h2", { className: "text-xs font-medium leading-6 text-zinc-950 dark:text-white", children: children }) }));
    }
    if (level === 3) {
        return (_jsx("div", { className: "my-1 py-1", children: _jsx("h2", { className: "text-xs font-medium leading-6 text-zinc-950 dark:text-white", children: children }) }));
    }
    return (_jsx("div", { className: "my-1 py-1", children: _jsx("h2", { className: "text-xs font-medium leading-6 text-zinc-500 dark:text-zinc-600", children: children }) }));
}
